import Box from '@material-ui/core/Box';
import React, { useEffect, useState } from 'react';

// pick a date util library
import { MenuItem, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { headerBarStyle } from '../../../styles';
import { allSites } from '../../../utils/Level/utils';


function VoucherHeader(props) {
  const classes = headerBarStyle();

  const [vtype, setVtype] = useState('BPV');
  const [vnum, setVnum] = useState('');
  const vouchers = ['BPV', 'BRV', 'CPV', 'CRV', 'JV','SALE'];
  const [indexEdit, setIndexEdit] = useState(props.editIndex);
  const [vIndex, setVindex] = useState(props.findIndex);
  const [sites, setSites] = useState(allSites);
  const [site, setSite] = useState(sites[0]?.id);

  const handleDate = event => {
    props.dateChange(event);
  };

  const handleChange = event => {
    setVtype(event.target.value);
    console.log(props);
    props.typeChange(event.target.value);
  };

  const handleSiteChange = event => {
    setSite(event.target.value);
    props.siteChange(event.target.value);
  };

  const handleIndex = event => {
    props.setFindIndex(event.target.value);
  };

  useEffect(() => {
    setVindex(props.findIndex);
  }, [props.findIndex]);

  useEffect(() => {
    setIndexEdit(props.editIndex);
  }, [props.editIndex]);

  return (
    <div
      className={classes.root}
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        backgroundColor:'#F5F5F5',
        // flex: 1,
        // backgroundColor: indexEdit ? '#379683' : '#8EE4AF',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          // backgroundColor: '#EDF5E1',
        }}
      >
        <Box sx={{ minWidth: 100 }}>
          <TextField
            style={{ width: '100%' }}
            id="voucher-type"
            select
            label="Voucher Type"
            value={props.type}
            variant='standard'
            onChange={handleChange}
            InputProps={{ disableUnderline: true, margin: 'dense' }}
          >
            {vouchers.map(option => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Box>

        {!indexEdit ? (
          <Box sx={{ minWidth: 150, marginLeft: 10 }}>
            <TextField
              style={{ width: '100%' }}
              id="site"
              select
              label="Site"
              variant='standard'
              value={props.site}
              onChange={handleSiteChange}
              InputProps={{ disableUnderline: true, margin: 'dense' }}
              InputLabelProps={{ shrink: true }}
            >
              {sites.map(option => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        ) : (
          <Box sx={{ minWidth: 150, marginLeft: 10 }}>
            <TextField
              style={{ width: '100%' }}
              id="site"
              select
              label="Site"
              variant='standard'
              value={props.site}
              InputProps={{
                disableUnderline: true,
                margin: 'dense',
                readOnly: true,
              }}
              InputLabelProps={{ shrink: true }}
            >
              {sites.map(option => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        )}

        <div
          style={{
            justifyContent: 'flex-start',
            alignSelf: 'flex-start',
            marginLeft: '10%',
          }}
        >
          {indexEdit ? (
            <TextField
              type="number"
              style={{ height: '100%' }}
              size="small"
              variant='standard'
              InputProps={{
                readOnly: true,
                disableUnderline: true,
              }}
              InputLabelProps={{ shrink: true }}
              id="outlined-disabled"
              label="Voucher #"
              value={vIndex}
              onChange={handleIndex}
              onClick={props.getVIndex}
              // value={props.voucherCurrentIndex}
            />
          ) : (
            <TextField
              type="number"
              style={{ height: '100%' }}
              size="small"
              variant='standard'
              InputProps={{
                readOnly: true,
                disableUnderline: true,
              }}
              InputLabelProps={{ shrink: true }}
              id="outlined-disabled"
              label="Voucher #"
              defaultValue={props.voucherCurrentIndex}
              value={props.voucherCurrentIndex}
            />
          )}
        </div>
        <div style={{ justifyContent: 'flex-start', alignSelf: 'flex-start' }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            size="small"
            label="Voucher Date"
            value={new Date(props.date)}
            onChange={(event) => handleDate(event)}
            disableFuture
            InputProps={{ disableUnderline: true }}
          />
        </LocalizationProvider>
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <TextField
          size="medium"
          variant='standard'
          InputProps={{
            disableUnderline: false,
          }}
          InputLabelProps={{ shrink: true }}
          id="outlined-disabled"
          label="Received By"
          defaultValue={vnum}
          onChange={event =>
            props.setVoucher({
              ...props.voucher,
              voucherRecBy: event.target.value,
            })
          }
          style={{ backgroundColor: '#EDF5E1' }}
        />
        <TextField
          size="small"
          variant='standard'
          InputProps={{
            disableUnderline: false,
          }}
          InputLabelProps={{ shrink: true }}
          id="outlined-disabled"
          label="Balance"
          defaultValue={vnum}
          onChange={event =>
            props.setVoucher({ ...props.voucher, balance: event.target.value })
          }
          style={{ backgroundColor: '#EDF5E1' }}
        />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <TextField
          size="medium"
          variant='standard'
          InputProps={{
            disableUnderline: false,
          }}
          InputLabelProps={{ shrink: true }}
          id="outlined-disabled"
          label="Deposited By"
          defaultValue={vnum}
          onChange={event =>
            props.setVoucher({
              ...props.voucher,
              voucherDepBy: event.target.value,
            })
          }
          style={{ backgroundColor: '#EDF5E1' }}
        />
        <TextField
          size="small"
          variant='standard'
          InputProps={{
            disableUnderline: false,
          }}
          InputLabelProps={{ shrink: true }}
          id="outlined-disabled"
          label="Invoice Bill#"
          defaultValue={vnum}
          onChange={event =>
            props.setVoucher({
              ...props.voucher,
              invoiceBillNum: event.target.value,
            })
          }
          style={{ backgroundColor: '#EDF5E1' }}
        />
      </div>
      <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
        <TextField
          size="medium"
          variant='standard'
          InputProps={{
            disableUnderline: false,
          }}
          InputLabelProps={{ shrink: true }}
          id="outlined-disabled"
          label="Description"
          defaultValue={vnum}
          style={{ backgroundColor: '#EDF5E1' }}
          onChange={event =>
            props.setVoucher({
              ...props.voucher,
              description: event.target.value,
            })
          }
        />
      </div>
    </div>
  );
}

export default VoucherHeader;
